const Footer = () => (
  <footer className="bg-[#1e3028] py-10">
    <div className="max-w-5xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div>
        <p className="text-white font-bold text-lg tracking-wide">atco</p>
        <p className="text-white/50 text-xs mt-1">株式会社atco</p>
      </div>
      <div className="flex flex-wrap gap-5 justify-center">
        {['ミッション','サービス','サービスの特徴','お客様の声','導入事例','会社概要','お問い合わせ','プライバシーポリシー'].map((label, i) => (
          <a key={i} href={`#${['mission','services','features','testimonials','cases','company','contact','privacy'][i]}`}
            className="text-white/60 hover:text-white text-xs transition-colors cursor-pointer whitespace-nowrap">
            {label}
          </a>
        ))}
      </div>
    </div>
    <div className="text-center mt-8">
      <p className="text-white/30 text-xs">&copy; {new Date().getFullYear()} 株式会社atco. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
